"use client";

import React from "react";
import { Plus, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: 1,
  title: "3.5 Tonne ATM Capacity"
}, {
  id: 2,
  title: "Dual Hydraulic Lifting Rams"
}, {
  id: 3,
  title: "Slide-Under Loading Ramps"
}, {
  id: 4,
  title: "Wireless Remote Tipping Control"
}];
export default function WhyChooseOurVenues() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="229657" id="10x5-hydraulic-tipper-trailer-with-plant-ramps" className="bg-background text-foreground font-default py-40 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">

          <div ref={leftColRef} className={`flex flex-col max-w-xl transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="text-muted-foreground font-default uppercase tracking-widest font-semibold text-sm mb-6 block">
              Heavy Duty Equipment
            </span>

            <div className="flex items-center gap-2 mb-6">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 border border-primary/20 bg-primary/5 text-primary font-mono text-xs uppercase tracking-wider">
                <MapPin className="size-3.5" />
                Sydney NSW
              </div>
            </div>

            <h2 className="text-foreground font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8">
              10x5 Hydraulic Tipper Trailer
            </h2>

            <p className="text-muted-foreground font-default text-lg md:text-xl leading-relaxed mb-12">
              Transport heavy machinery and bulk materials with ease. Our premium
              10x5 tipper is equipped with heavy-duty plant ramps and a
              high-performance hydraulic system, making it the ultimate tool for
              professional contractors and DIY experts alike.
            </p>

            <ul className="space-y-6 mb-12">
              {features.map((feature, i) => <li key={feature.id} data-index={i} className="flex items-center gap-4">
                  <div className="bg-primary/10 p-1.5 rounded-md shrink-0">
                    <Plus className="text-primary size-5 stroke-[3]" />
                  </div>
                  <span className="text-foreground font-medium font-default text-lg">
                    {feature.title}
                  </span>
                </li>)}
            </ul>

            <div>
              <Button asChild size="lg" className="h-14 px-8 text-base shadow-lg">
                <Link to="https://set-starfish.10web.cloud/contact/">
                  Enquire Now
                </Link>
              </Button>
            </div>
          </div>

          <div ref={rightColRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="absolute -inset-6 md:-inset-10 bg-muted rounded-3xl -z-10 translate-x-6 translate-y-6 md:translate-x-10 md:translate-y-10"></div>

            <div className="relative rounded-2xl overflow-hidden shadow-2xl transition-transform duration-700 ease-[cubic-bezier(0.25,1,0.5,1)] hover:scale-[0.95] bg-card">
              <img src="https://bottomupprojects.com.au/wp-content/uploads/2026/04/TP105_3500kg_05.webp" alt="10x5 Hydraulic Tipper Trailer with Plant Ramps for hire" className="w-full h-auto object-contain aspect-[3/4] object-center" loading="lazy" decoding="async" />

              <div className="absolute inset-0 bg-gradient-to-tr from-foreground/5 to-transparent pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}